import { baseAxios, errorHandler } from "../index";

export async function getAllTotalSupervisor(dispatch) {
  try {
    const response = await baseAxios.get("webDashboard/getTotalSupervisor", {
      headers: { token: localStorage.getItem("token") },
    });
    // console.log(response, "???????????");
    dispatch({ type: "SET_ALL_TOTAL_SUPERVISOR", data: response.data });
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getAllTotalAreaManager(dispatch) {
  try {
    const response = await baseAxios.get("webDashboard/getTotalAreaManager", {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({ type: "SET_ALL_TOTAL_AREAMANAGER", data: response.data });
    // console.log(response, "???????????");
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getAllTotalMarketing(dispatch) {
  try {
    const response = await baseAxios.get("webDashboard/getTotalMarketing", {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({ type: "SET_ALL_TOTAL_MARKETING", data: response.data });
    // console.log(response, "???????????");
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getAllTotalCabang(dispatch) {
  try {
    const response = await baseAxios.get("webDashboard/getTotalCabang", {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({ type: "SET_ALL_TOTAL_CABANG", data: response.data });
    // console.log(response, "???????????");
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getAllTotalPengajuan(dispatch, data, history) {
  // console.log(data, "LL");
  try {
    const response = await baseAxios.post(
      "webPengajuan/getAllTotalPengajuan",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    dispatch({ type: "SET_AMBIL_PENGAJUAN", data: response.data.data });
    dispatch({ type: "SET_ALL_TOTAL_PENGAJUAN", data: response.data });
    // console.log(response, "PP");
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getGrafikPencairanCabang(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/getGrafikPencairanCabang",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    // dispatch({ type: "SET_ALL_PENCAIRAN", data: response.data });
    // console.log(response);
    return response;
  } catch (err) {
    // return err.response;
    return errorHandler(err.response);
  }
}

export async function getGrafikPencairanUser(dispatch, data, history) {
  try {
    const response = await baseAxios.post(
      "webDashboard/getGrafikPencairanPerBulanByLogin",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    // dispatch({ type: "SET_ALL_PENCAIRAN", data: response.data });
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getExportPengajuan(data) {
  // console.log(data, "KKK");
  try {
    const response = await baseAxios.post(
      "webPengajuan/exportSementara",
      data,
      {
        headers: { token: localStorage.getItem("token") },
        responseType: "blob",
      }
    );
    return response;
  } catch (err) {
    return errorHandler(err.response);
  }
}

export async function getAllWilayah(dispatch, data, history) {
  try {
    const response = await baseAxios.get("/wilayah/getAllWilayah", {
      headers: { token: localStorage.getItem("token") },
    });
    dispatch({ type: "SET_ALL_WILAYAH", data: response.data.data });
    return response;
  } catch (err) {
    return err.response;
  }
}
